module.exports = __webpack_public_path__ + "img/idea-committee@2x.7cf58e12.webp";